module.exports = __webpack_public_path__ + "static/media/image-placeholder.27ea510f.png";